import { UPDATE_ASSIGNED_TAGS, UPDATE_CREATED_TAGS } from '../../actions/tag_actions';
import { RECEIVE_ALL_WORK_INSTRUCTIONS, 
        REMOVE_WORK_INSTRUCTION,
        ADD_WORK_INSTRUCTION,
        UPDATE_WORK_INSTRUCTION,
        UPDATED_RELEASED_WORK_INSTRUCTIONS
} from '../../actions/wi_actions';
import { RECEIVE_USER_LOGOUT } from '../../actions/session_actions';
import { mapKeys, cloneDeep, omit} from "lodash"

const all_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    let newState = cloneDeep(oldState)
    switch (action.type) {
        case RECEIVE_ALL_WORK_INSTRUCTIONS:
            // Payload is directly the array: action.workInstructions
            const WorkInstructions = mapKeys(action.workInstructions, "_id") // Use action.workInstructions directly
            let normalizedWorkInstructions = { ...newState, ...WorkInstructions }
            return normalizedWorkInstructions
        case REMOVE_WORK_INSTRUCTION:
            return omit(newState, action.workInstruction.wip_id)
        case UPDATE_WORK_INSTRUCTION:
            const revisedState = cloneDeep(newState)
            revisedState[action.updatedWorkInstruction._id] = action.updatedWorkInstruction;
            return revisedState
        case UPDATE_ASSIGNED_TAGS:
            const updatedTagsState = cloneDeep(newState)
            updatedTagsState[action.tags.wip_id].tags = action.tags.reduxTags;
            return updatedTagsState
        case ADD_WORK_INSTRUCTION:
            const newInstructions = cloneDeep(newState)
            newInstructions[action.workInstruction._id] = action.workInstruction;
            return newInstructions
        case UPDATE_CREATED_TAGS:
            const updatedWorkInstructions = cloneDeep(newState)
            updatedWorkInstructions[action.data.wip_id].tags = action.data.tags
            return updatedWorkInstructions 
        case UPDATED_RELEASED_WORK_INSTRUCTIONS:
            newState[action.workInstruction._id] = action.workInstruction
            return newState
        case RECEIVE_USER_LOGOUT:
            return {};
        default:
            return newState;
    }
};

export default all_reducer;